import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {EventsComponent} from "./components/events/events.component";
import {UnitsComponent} from "./components/units/units.component";
import {AuthGuard} from "./auth.guard";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {DonationtableComponent} from "./components/Donationt/donationtable/donationtable.component";
import {ViewDonationComponent} from "./components/Donationt/view-donation/view-donation.component";
import {ListCaretakerComponent} from "./components/caretakers/list-caretaker/list-caretaker.component";
import {TypesComponent} from "./components/types/types.component";
import {GetreceiptComponent} from "./components/Donationt/getreciept/getreceipt.component";
import {MyTestComponent} from "./my-test/my-test.component";
import {ViewEventComponent} from "./components/events/view-event/view-event.component";
import {LogoutComponent} from "./logout/logout.component";
import {BulkUploadComponent} from "./bulk-upload/bulk-upload.component";
import {RazorpayDataComponent} from "./components/razorpay-data/razorpay-data.component";
import {RenameComponent} from "./components/rename/rename.component";
import {ActivityLogComponent} from "./components/activity-log/activity-log.component";
import {EmployeelistComponent} from "./components/employee/employeelist/employeelist.component";
import {MainComponent} from "./main/main.component";
import {GlossaryComponent} from "./components/glossary/glossary.component";
import {RazorpayTransactionComponent} from "./components/razorpay-transaction/razorpay-transaction.component";
import {CodeComponent} from "./code/code.component";
import {QuarterReportComponent} from "./quarter-report/quarter-report.component";
import {PhotoGalleryComponent} from "./components/photo-gallery/photo-gallery.component";
import {CountTableComponent} from "./modules/reports/ops-reports/count-table/count-table.component";
import {DynamicTableComponent} from "./modules/reports/ops-reports/dynamic-table/dynamic-table.component";
import {ChildReportComponent} from "./modules/reports/ops-reports/child-report/child-report.component";
import {CentreEfficiencyComponent} from "./components/dashboard/centre-efficiency/centre-efficiency.component";
import {DataCorrectionComponent} from "./components/data-correction/data-correction.component";
import {ManualDonationComponent} from "./components/Donationt/manual-donation/manual-donation.component";
import {AttemptedDonationComponent} from "./modules/inventory/attempted-donation/attempted-donation.component";
import {FailedDonationsComponent} from "./components/Donationt/failed-donations/failed-donations.component";
import {
  ManualAttemptedDonationRecieptComponent
} from "./components/Donationt/manual-attempted-donation-reciept/manual-attempted-donation-reciept.component";
import {GetPlacesComponent} from "./get-places/get-places.component";
import {MisBorivaliComponent} from "./components/dashboard/mis-borivali/mis-borivali.component";
import {EditRolePermissionsComponent} from "./components/employee/edit-rol-permissions/edit-role-permissions.component";
import {NotificationViewComponent} from "./components/notification-view/notification-view.component";
import {MisDonationComponent} from "./components/dashboard/mis-donation/mis-donation.component";
import {MisEducationComponent} from "./components/dashboard/mis-education/mis-education.component";
import {MisCounsellingComponent} from "./components/dashboard/mis-counselling/mis-counselling.component";
import {MisTransportComponent} from "./components/dashboard/mis-transport/mis-transport.component";
import {MisOprationsComponent} from "./components/dashboard/mis-oprations/mis-oprations.component";
import {PaymentRemindersComponent} from "./components/reminders/payment-reminders/payment-reminders.component";
import {FollowupAdmissionComponent} from "./components/reminders/followup-admission/followup-admission.component";
import {YourdriveIntegrationComponent} from "./components/yourdrive-integration/yourdrive-integration.component";
import {DbmsComponent} from "./components/dbms/dbms.component";
import {AddRolePermissionsComponent} from "./components/employee/add-role-permissions/add-role-permissions.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },


  {path: 'getreceipt/:id', component: GetreceiptComponent},
  {
    path: 'home',

    component: MainComponent,
    canActivate: [AuthGuard],
    children: [

      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },

      {path: 'code', component: CodeComponent},
      {
        path: 'gemini',
        loadChildren: () => import('./modules/gemini/gemini.module').then(m => m.GeminiModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'yourdrive-integration',
        component: YourdriveIntegrationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'dms',
        component: DbmsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'quarterly-report',
        component: QuarterReportComponent
      },
      {
        path: 'mis-borivali',
        component: MisBorivaliComponent
      },
      {
        path: 'mis-donation',
        component: MisDonationComponent
      }, {
        path: 'mis-education',
        component: MisEducationComponent
      },
      {
        path: 'mis-counselling',
        component: MisCounsellingComponent
      },
      {
        path: 'mis-operations',
        component: MisOprationsComponent
      },
      {
        path: 'mis-transport',
        component: MisTransportComponent
      },
      {
        path: 'types',
        component: TypesComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "child-list",
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule),
        canActivate: [AuthGuard]
      },
      {
        path: "prescreening",
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule),
        canActivate: [AuthGuard]
      },
      {
        path: "child-admission",
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admission-view',
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule),
        canActivate: [AuthGuard]
      },
      {
        path: "edit-admission",
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule),
        canActivate: [AuthGuard]
      },
      {
        path: "child-journey",
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'child-excel',
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule)
      },
      {
        path: 'child-edit-admin/:id',
        loadChildren: () => import('./modules/child-management/child-management.module').then(m => m.ChildManagementModule)
      },
      {
        path: "dc",
        component: DataCorrectionComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "manual-donation",
        component: ManualDonationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "attempted-donations",
        component: AttemptedDonationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "failed-donations",
        component: FailedDonationsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "manual-donation/:id",
        component: ManualDonationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "manual-attempted-donation/:id",
        component: ManualAttemptedDonationRecieptComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "photo-gallery",
        component: PhotoGalleryComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "storage-gallery",
        loadChildren: () => import('./storage-gallery/storage-gallery.component').then(m => m.StorageGalleryComponent),
        canActivate: [AuthGuard]
      },
      {
        path: "department-access",
        loadChildren: () => import('./modules/department-access/department-access.component').then(m => m.DepartmentAccessComponent),
        canActivate: [AuthGuard]
      },
      {
        path: "shared-files",
        loadChildren: () => import('./modules/department-access/shared-files/shared-files.component').then(m => m.SharedFilesComponent),
        canActivate: [AuthGuard]
      },

      {
        path: "rename",
        component: RenameComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "razorpay-transaction",
        component: RazorpayTransactionComponent,
        canActivate: [AuthGuard]
      },


      {
        path: "razorpay-data",
        component: RazorpayDataComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "centres",
        loadChildren: () => import('./modules/centres/centres.module').then(m => m.CentresModule),
        canActivate: [AuthGuard]
      },
      {
        path: "createcenter",
        loadChildren: () => import('./modules/centres/centres.module').then(m => m.CentresModule),
        canActivate: [AuthGuard]
      },
      {
        path: "allcentres",
        loadChildren: () => import('./modules/centres/centres.module').then(m => m.CentresModule),
        canActivate: [AuthGuard],

      },
      {
        path: "users",
        component: EmployeelistComponent,
        canActivate: [AuthGuard],

      },

      {
        path: "Events",
        // component: UnderConstructionComponent,
        component: EventsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "Events/:id",
        // component: UnderConstructionComponent,
        component: ViewEventComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "reminders",
        loadChildren: () => import('./modules/reminders/reminders.module').then(m => m.RemindersModule),
        canActivate: [AuthGuard]
      },
      {
        path: "payments",
        loadChildren: () => import('./modules/reminders/reminders.module').then(m => m.RemindersModule),
        canActivate: [AuthGuard]
      },
      {
        path: "followup-admissions",
        loadChildren: () => import('./modules/reminders/reminders.module').then(m => m.RemindersModule),
        canActivate: [AuthGuard]
      },
      {
        path: "unitsponsorship",
        loadChildren: () => import('./modules/unit-sponsorship/unit-sponsorship.module').then(m => m.UnitSponsorshipModule),
        canActivate: [AuthGuard]
      },
      {
        path: "unitsponsorship/count-table",
        component: CountTableComponent,
        // component: DashboardRemindersComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "Donor",
        loadChildren: () => import('./modules/donors/donors.module').then(m => m.DonorsModule),
        canActivate: [AuthGuard]
      },
      {
        path: "donor-profile/:id",
        loadChildren: () => import('./modules/donors/donors.module').then(m => m.DonorsModule),
        canActivate: [AuthGuard]
      },

      {
        path: "activitylog",
        component: ActivityLogComponent,
        // component: ActivitiesComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "Units",
        component: UnitsComponent,
        canActivate: [AuthGuard]
      },


      // {
      //   path: "CMS",
      //   loadChildren: () => import('./modules/cms/cms.module').then(m => m.CmsModule)
      //
      // },
      {
        path: "hospitals",
        loadChildren: () => import('./modules/hospitals/hospitals.module').then(m => m.HospitalsModule)

      },
      {
        path: "education",
        loadChildren: () => import('./modules/education/education.module').then(m => m.EducationModule),
        canActivate: [AuthGuard]

      },
      {
        path: "sop",
        loadChildren: () => import('./modules/sop/sop.module').then(m => m.SopModule)
      },
      {
        path: 'tasks',
        loadChildren: () => (import('./modules/task/task.module').then(m => m.TaskModule)),
        canActivate: [AuthGuard]
      },
      {
        path: 'volunteer',
        loadChildren: () => (import('./modules/volunteer/volunteer.module').then(m => m.VolunteerModule)),
      },
      {
        path: 'prefix',
        loadChildren: () => (import('./modules/prefix-mater/prefix-mater.module').then(m => m.PrefixMaterModule)),
      },
      {
        path: 'media',
        loadChildren: () => (import('./modules/media-coverage/media-coverage.module').then(m => m.MediaCoverageModule)),
      },
      {
        path: 'award',
        loadChildren: () => (import('./modules/award-recognition/award-recognition.module').then(m => m.AwardRecognitionModule)),
      },
      {
        path: 'membership',
        loadChildren: () => (import('./modules/membership/membership.module').then(m => m.MembershipModule)),
      },
      {
        path: 'staff-learning',
        loadChildren: () => (import('./modules/staff-learning-session/staff-learning.module').then(m => m.StaffLearningModule)),
      },
      {
        path: 'email',
        loadChildren: () => (import('./modules/email/email-notification/email-notification.module').then(m => m.EmailNotificationModule)),
      },
      {
        path: "reports",
        loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: "questions",
        loadChildren: () => import('./modules/questions/questions.module').then(m => m.QuestionsModule)
      },
      {
        path: "changeLog",
        loadChildren: () => import('./modules/change-log/change-log.module').then(m => m.ChangeLogModule)
      },
      {
        path: "inquiry-8080",
        loadChildren: () => import('./modules/inquiry-8080/inquiry-8080.module').then(m => m.Inquiry8080Module)
      },

      {path: 'feedback', loadChildren: () => import('./modules/feedback/feedback.module').then(m => m.FeedbackModule)},
      {path: 'mom', loadChildren: () => import('./modules/mom/mom.module').then(m => m.MomModule)},
      {path: 'vehicles', loadChildren: () => import('./modules/vehicles/vehicles.module').then(m => m.VehiclesModule)},
      {
        path: "Caretakers",
        // component: UnderConstructionComponent,

        component: ListCaretakerComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'dynamic-table',
        component: DynamicTableComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "glossary",
        component: GlossaryComponent,
        canActivate: [AuthGuard]
      },

      {
        path: "child-report-x",
        // component: VehiclesComponent
        component: ChildReportComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'notifications',
        component: NotificationViewComponent
      },
      {
        path: "donation",
        component: DonationtableComponent,
        canActivate: [AuthGuard],
        children: [
          // {path: 'getreceipt/:id', component: GetreceiptComponent},

        ]
      },
      // {
      //   path: "meals",
      //   canActivate: [AuthGuard],
      //   component: MealsComponent,
      //   children: [
      //     {
      //       path: "",
      //       pathMatch: 'full',
      //       component: MealsCalenderComponent,
      //       canActivate: [AuthGuard]
      //     },
      //     {
      //       path: "allevents",
      //       pathMatch: 'full',
      //       component: MealMateEventTableComponent,
      //       canActivate: [AuthGuard]
      //     },
      //     {
      //       path: "slots",
      //       component: MealSlotsComponent,
      //       canActivate: [AuthGuard]
      //     },
      //     {
      //       path: 'bookings',
      //       component: ManageOnlineSlotsComponent,
      //       canActivate: [AuthGuard]
      //     }
      //
      //   ]
      // },
      {
        path: "view-donation",
        component: ViewDonationComponent,
        canActivate: [AuthGuard]
      },
      // {
      //   path: "education",
      //   component: UnderConstructionComponent,
      //   canActivate: [AuthGuard]
      // },
      {
        path: 'counseling',
        loadChildren: () => import('./modules/counseling/counseling.module').then(m => m.CounselingModule)
      },
      {
        path: 'highlights',
        loadChildren: () => import('./modules/consolidated-highlights/consolidated-highlights.module').then(m => m.ConsolidatedHighlightsModule)
      },
      {
        path: 'meals',
        loadChildren: () => import('./modules/meal-mate/meal-mate.module').then(m => m.MealMateModule)
      },
      // {path: 'getreceipt/:id', component: GetreceiptComponent},

      {
        path: 'inventory',
        loadChildren: () => import('./modules/inventory/inventory.module').then(m => m.InventoryModule)
      },
      {
        path: 'ticketing',
        loadChildren: () => import('./modules/ticketing/ticketing.module').then(m => m.TicketingModule)
      },
      {
        path: 'agreements',
        loadChildren: () => import('./modules/agreements/agreements.module').then(m => m.AgreementsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'donations',
        loadChildren: () => import('./modules/donations/donations.module').then(m => m.DonationsModule)
      },
      {
        path: "edit-permissions",
        component: EditRolePermissionsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'testimonials',
        loadChildren: () => import('./modules/testimonials/testimonials.module').then(m => m.TestimonialsModule),
        canActivate: [AuthGuard]
      },
    ]
  },

  // {
  //   path: "",
  //   component: HeaderComponent
  // },

  // { path: '',   redirectTo: '/dashboard', pathMatch: 'full' }, // redirect to `first-component`

  //lazyloading

  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "logout",
    component: LogoutComponent
  },
  {
    path: 'test',
    component: MyTestComponent
  },
  {
    path: 'bulk',
    component: BulkUploadComponent
  },
  {
    path: "places",
    component: GetPlacesComponent,
    canActivate: [AuthGuard]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
